/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { LeftBorderHeadline } from "components/atoms/headline/LeftBorderHeadline";
import { PurchaseTicketSkeleton } from "components/loading/SkeletonLoader";
import { useI18n } from "hooks/i18n/i18n";
import React, { useEffect, useRef } from "react";
import { changeStyleWithHosting } from "utility/hosting";

import { EventVideoTicketList } from "./EventVideoTicketList";

type Props = React.ComponentProps<typeof EventVideoTicketList>;
export const EventDetailPurchaseTicket: React.FC<Props> = (props) => {
  const { t } = useI18n();
  const { eventVideoMap, streamingKey } = props;
  const classesHeadingDesign = headingDesign();
  const ref = useRef<HTMLDivElement>(null);

  const isReady = !!streamingKey && !!eventVideoMap;

  /**
   * URLのハッシュに#ticketがある場合、チケット販売セクションまでスクロールされるようにする
   */
  useEffect(() => {
    if (isReady && window.location.hash === "#ticket") {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [isReady]);
  if (!isReady) {
    return <PurchaseTicketSkeleton />;
  }
  return (
    <div id="ticket" ref={ref} css={classesHeadingDesign.root}>
      <div css={classesHeadingDesign.heading}>
        <LeftBorderHeadline
          title={t("event.headline.streamingTicket.text")}
          subTitle={t("event.headline.streamingTicket.subText")}
          fontColor={"secondary"}
        />
      </div>
      <EventVideoTicketList {...props} />
    </div>
  );
};

const headingDesign = () => {
  const _hostingBaseStyleMap = changeStyleWithHosting().baseStyles;
  return {
    root: css`
      margin-top: 50px;
    `,
    heading: css`
      margin-bottom: 40px;
    `,
    charityText: css`
      margin-bottom: 20px;
      p {
        line-height: 1.5em;
      }
    `,
  };
};
